import { core } from './enCore';
import { content } from './enContent';
import { system } from './enSystem';

export const en = {
    ...core,
    ...content,
    ...system,
};
